import React from 'react';
import { Header } from '../../../components/ToxicDetector/Header';
import { HeroSection } from '../../../components/ToxicDetector/HeroSection';
import { TrustSection } from '../../../components/ToxicDetector/TrustSection';
import { FeaturesSection } from '../../../components/ToxicDetector/FeaturesSection';
import { ForensicEvidenceSection } from '../../../components/ToxicDetector/ForensicEvidenceSection';
import { GuaranteesSection } from '../../../components/ToxicDetector/GuaranteesSection';
import { ToolsSection } from '../../../components/ToxicDetector/ToolsSection';
import { ComparisonSection } from '../../../components/ToxicDetector/ComparisonSection';
import { PricingSection } from '../../../components/ToxicDetector/PricingSection';
import { FAQSection } from '../../../components/ToxicDetector/FAQSection';
import { CTASection } from '../../../components/ToxicDetector/CTASection';
import { Footer } from '../../../components/ToxicDetector/Footer';
import { MetaTags } from '../../../components/SEO/MetaTags';
import { PromoBanner } from '../../../components/Notifications/PromoBanner';
import { GoogleTranslateWidget } from '../../../components/GoogleTranslateWidget';
export function LandingPageDE() {
  const alternateUrls = [{
    lang: 'en',
    url: 'https://toxicdetector.com/'
  }, {
    lang: 'pt-BR',
    url: 'https://toxicdetector.com/pt/'
  }, {
    lang: 'es-MX',
    url: 'https://toxicdetector.com/es/'
  }, {
    lang: 'ja',
    url: 'https://toxicdetector.com/ja/'
  }, {
    lang: 'ko',
    url: 'https://toxicdetector.com/ko/'
  }, {
    lang: 'de',
    url: 'https://toxicdetector.com/de/'
  }, {
    lang: 'fr',
    url: 'https://toxicdetector.com/fr/'
  }, {
    lang: 'hi',
    url: 'https://toxicdetector.com/hi/'
  }, {
    lang: 'id',
    url: 'https://toxicdetector.com/id/'
  }];
  return <>
      <MetaTags title="ToxicDetector: KI-Beziehungsanalyse | Toxische Muster & Gaslighting erkennen" description="Finden Sie heraus, ob Ihr Ex das Problem ist. Laden Sie Ihre Chats in die KI von ToxicDetector hoch, um eine sofortige, vertrauliche Analyse von Manipulation, Gaslighting und Warnsignalen zu erhalten. Starten Sie jetzt den kostenlosen Scan." keywords="KI-Beziehungsanalyse, toxische Muster erkennen, Gaslighting-Detektor, toxischer Ex, Manipulationsprüfung, Beziehungstoxizität, KI-Textscanner" canonical="https://toxicdetector.com/de" language="de" alternateUrls={alternateUrls} data-id="element-4829" />
      <GoogleTranslateWidget data-id="element-4830" />
      <PromoBanner data-id="element-4831" />
      <div className="flex flex-col w-full min-h-screen bg-gradient-to-b from-stone-50 to-white" data-id="element-4832">
        <Header data-id="element-4833" />
        <main data-id="element-4834">
          <HeroSection h1Override={<>
                Dein Gehirn{' '}
                <span className="relative inline-block" data-id="element-4836">
                  <span className="relative z-10 text-transparent bg-clip-text bg-gradient-to-b from-gray-200 to-gray-500" data-id="element-4837">
                    Lügt
                  </span>
                  <span className="absolute top-1/2 left-0 w-full h-[4px] md:h-[6px] bg-[#FF0000] -translate-y-1/2 rotate-[-2deg]" data-id="element-4838" />
                </span>{' '}
                Dich an.
                <br data-id="element-4839" />
                <span className="text-[#FF0000] drop-shadow-[0_0_30px_rgba(255,0,0,0.4)]" data-id="element-4840">
                  Unsere KI nicht.
                </span>
              </>} data-id="element-4835" />
          <TrustSection data-id="element-4841" />
          <FeaturesSection data-id="element-4842" />
          <ForensicEvidenceSection data-id="element-4843" />
          <GuaranteesSection data-id="element-4844" />
          <ToolsSection data-id="element-4845" />
          <ComparisonSection data-id="element-4846" />
          <PricingSection data-id="element-4847" />
          <FAQSection data-id="element-4848" />
          <CTASection data-id="element-4849" />
        </main>
        <Footer data-id="element-4850" />
      </div>
    </>;
}